/*
  FICHE — comportements
  Pour Adrien d'Elzius · fiche v2

  Le format choisi pilote tout : le prix, le bouton, la barre collante et
  l'échelle. L'ajout au panier se fait sans quitter l'œuvre ; le panier
  s'ouvre sur place et le compteur de l'en-tête suit (événement du thème).
  Sans JavaScript, le formulaire reste un formulaire Shopify ordinaire.
*/
(function () {
  if (window.__ficInit) return;
  window.__ficInit = true;

  var calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function glisse() { return calme.matches ? 'auto' : 'smooth'; }
  function argent(cents, modele) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (modele || '{{ amount }} €').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function demarrer(root) {
    var fic = $('[data-fic]', root) || (root.matches && root.matches('[data-fic]') ? root : null);
    if (!fic || fic.__fic) return;
    fic.__fic = 1;

    var bar = $('[data-fic-sticky]');
    if (bar && bar.parentNode !== document.body) document.body.appendChild(bar);
    ['[data-fic-lb]', '[data-fic-gf]', '[data-fic-cart]'].forEach(function (s) {
      var d = $(s, fic);
      if (d) document.body.appendChild(d);
    });
    var lb = $('[data-fic-lb]');
    var gf = $('[data-fic-gf]');
    var panier = $('[data-fic-cart]');
    var form = $('[data-fic-panel="a1"] form', fic);
    var cta = $('[data-fic-cta]', fic);
    var modele = fic.getAttribute('data-money') || '{{ amount }} €';

    /* ────────── le format ────────── */
    var fmt = 'a1';
    function format(f) {
      fmt = f;
      fic.setAttribute('data-fmt', f);
      var prix = fic.getAttribute('data-price-' + f) || '';
      var note = fic.getAttribute('data-note-' + f) || '';
      $$('[data-fic-price]').forEach(function (el) { el.textContent = prix; });
      $$('[data-fic-pnote]').forEach(function (el) { el.textContent = note; });
      $$('[data-fic-panel]', fic).forEach(function (p) { p.hidden = p.getAttribute('data-fic-panel') !== f; });
      $$('[data-fic-fmtdetail]', fic).forEach(function (p) { p.hidden = p.getAttribute('data-fic-fmtdetail') !== f; });
      if (bar) {
        var n = $('[data-fic-bar-fmt]', bar);
        var b = $('[data-fic-bar-btn]', bar);
        if (n) n.textContent = fic.getAttribute('data-name-' + f) || '';
        if (b) {
          var bl = b.querySelector('.fic__cta-l--rest');
          (bl || b).textContent = fic.getAttribute('data-act-' + f) || '';
        }
      }
      document.dispatchEvent(new CustomEvent('fic:format', { detail: { format: f } }));
    }
    $$('input[name="fic-format"]', fic).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) format(r.value); });
      if (r.checked) fmt = r.value;
    });
    format(fmt);

    /* ────────── la galerie ────────── */
    var piste = $('[data-fic-track]', fic);
    var vignettes = $$('[data-fic-thumb]', fic);
    var compte = $('[data-fic-count]', fic);
    var total = piste ? piste.children.length : 0;
    var courant = 0;
    function marquer(i) {
      courant = i;
      vignettes.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (compte) compte.textContent = (i + 1) + ' / ' + total;
    }
    function allerA(i) {
      if (!piste) return;
      piste.scrollTo({ left: i * piste.clientWidth, behavior: glisse() });
      marquer(i);
    }
    if (piste) {
      var t = 0;
      piste.addEventListener('scroll', function () {
        if (t) return;
        t = requestAnimationFrame(function () {
          t = 0;
          marquer(Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)));
        });
      }, { passive: true });
      vignettes.forEach(function (v, i) { v.addEventListener('click', function () { allerA(i); }); });
      marquer(0);
    }

    /* ────────── la loupe ────────── */
    var sources = $$('[data-fic-zoom]', fic).map(function (b) {
      return { src: b.getAttribute('data-src'), alt: b.getAttribute('data-alt') || '' };
    });
    var lbIdx = 0;
    function lbMontrer(i) {
      if (!lb || !sources.length) return;
      lbIdx = (i + sources.length) % sources.length;
      var img = $('img', lb);
      lb.classList.remove('is-zoom');
      img.src = sources[lbIdx].src;
      img.alt = sources[lbIdx].alt;
      var c = $('[data-fic-lb-count]', lb);
      if (c) c.textContent = (lbIdx + 1) + ' / ' + sources.length;
    }
    if (lb && typeof lb.showModal === 'function') {
      $$('[data-fic-zoom]', fic).forEach(function (b, i) {
        b.addEventListener('click', function () { lbMontrer(i); lb.showModal(); });
      });
      var zb = $('[data-fic-zoom-btn]', fic);
      if (zb) zb.addEventListener('click', function () { lbMontrer(courant); lb.showModal(); });
      $('[data-fic-lb-prev]', lb).addEventListener('click', function () { lbMontrer(lbIdx - 1); });
      $('[data-fic-lb-next]', lb).addEventListener('click', function () { lbMontrer(lbIdx + 1); });
      $('[data-fic-lb-close]', lb).addEventListener('click', function () { lb.close(); });
      $('img', lb).addEventListener('click', function (e) {
        var r = e.target.getBoundingClientRect();
        lb.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100) + '%');
        lb.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100) + '%');
        lb.classList.toggle('is-zoom');
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); lbMontrer(lbIdx - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); lbMontrer(lbIdx + 1); }
      });
      lb.addEventListener('close', function () { lb.classList.remove('is-zoom'); allerA(lbIdx); });
    }

    /* ────────── le panier sur place ────────── */
    function ouvrirPanier(cart, ligne) {
      if (!panier) { window.location.href = '/cart'; return; }
      var img = $('[data-fic-cart-img]', panier);
      var nom = $('[data-fic-cart-name]', panier);
      var var_ = $('[data-fic-cart-variant]', panier);
      var px = $('[data-fic-cart-price]', panier);
      var tot = $('[data-fic-cart-total]', panier);
      var nb = $('[data-fic-cart-count]', panier);
      if (img && ligne && ligne.image) { img.src = ligne.image + (ligne.image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.alt = ''; }
      if (nom && ligne) nom.textContent = ligne.product_title;
      if (var_) var_.textContent = fic.getAttribute('data-name-a1') || '';
      if (px && ligne) px.textContent = argent(ligne.final_line_price, modele);
      if (tot) tot.textContent = argent(cart.total_price, modele);
      if (nb) nb.textContent = cart.item_count;
      if (typeof panier.showModal === 'function') panier.showModal(); else panier.setAttribute('open', '');
    }
    if (panier) {
      $$('[data-fic-cart-close]', panier).forEach(function (b) { b.addEventListener('click', function () { panier.close(); }); });
      panier.addEventListener('click', function (e) { if (e.target === panier) panier.close(); });
    }

    /* Trois états, sur le bouton principal et sur celui de la barre :
       repos → roue qui tourne → ajouté. Le libellé est annoncé aux
       lecteurs d'écran par une zone discrète. */
    var live = $('[data-fic-live]', fic);
    var barBtn = bar ? $('[data-fic-bar-btn]', bar) : null;
    var retour = 0;
    function etat(mode) {
      [cta, barBtn].forEach(function (b) {
        if (!b) return;
        b.setAttribute('data-state', mode);
        if (mode === 'busy') b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
      if (live) live.textContent = mode === 'busy' ? (fic.getAttribute('data-busy') || '') : mode === 'done' ? (fic.getAttribute('data-done') || '') : '';
      clearTimeout(retour);
      if (mode === 'done') retour = setTimeout(function () { etat('rest'); }, 2600);
    }
    function patienter(t0, ms) {
      var reste = ms - (Date.now() - t0);
      return new Promise(function (ok) { setTimeout(ok, reste > 0 ? reste : 0); });
    }

    if (form && window.fetch && window.FormData) {
      var err = $('[data-fic-error]', fic);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (cta && cta.getAttribute('data-state') === 'busy') return;
        etat('busy');
        if (err) err.textContent = '';
        var ajoute = null;
        var t0 = Date.now();
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        }).then(function (item) {
          ajoute = item;
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (cart) {
          /* La roue reste visible au moins un instant : un ajout trop
             rapide ne se voit pas, et on doute qu'il ait eu lieu. */
          return patienter(t0, 650).then(function () { return cart; });
        }).then(function (cart) {
          etat('done');
          var ev = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'fiche', data: { itemCount: cart.item_count, source: 'fiche' } } });
          document.dispatchEvent(ev);
          var ligne = null;
          (cart.items || []).forEach(function (l) { if (ajoute && l.variant_id === ajoute.variant_id) ligne = l; });
          ouvrirPanier(cart, ligne || ajoute);
        }).catch(function (j) {
          etat('rest');
          if (err) err.textContent = (j && (j.description || j.message)) || fic.getAttribute('data-fail') || '';
        });
      });
    }

    /* ────────── paiement express : la roue pendant la redirection ────────── */
    var express = $('.fic__express', fic);
    if (express) {
      express.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('.shopify-payment-button__button--unbranded')) return;
        express.classList.add('is-busy');
        setTimeout(function () { express.classList.remove('is-busy'); }, 8000);
      }, true);
      window.addEventListener('pageshow', function () { express.classList.remove('is-busy'); });
    }

    /* ────────── la demande de grand format ────────── */
    function ouvrirGF() {
      if (!gf || typeof gf.showModal !== 'function') return;
      gf.showModal();
      var champ = $('input[name="contact[name]"]', gf);
      if (champ && !champ.value) setTimeout(function () { champ.focus(); }, 60);
    }
    $$('[data-fic-gf-open]').forEach(function (b) { b.addEventListener('click', ouvrirGF); });
    if (gf) {
      $$('[data-fic-gf-close]', gf).forEach(function (b) { b.addEventListener('click', function () { gf.close(); }); });
      gf.addEventListener('click', function (e) { if (e.target === gf) gf.close(); });
      if ($('[data-fic-gf-flag]', gf)) {
        var radio = $('input[name="fic-format"][value="gf"]', fic);
        if (radio) { radio.checked = true; format('gf'); }
        ouvrirGF();
      }
    }

    /* ────────── la barre collante ────────── */
    var zone = $('[data-fic-cta-zone]', fic);
    if (bar && zone && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          var on = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on);
          document.body.classList.toggle('fic-bar-on', on);
        });
      }, { threshold: 0 }).observe(zone);
      var bb = $('[data-fic-bar-btn]', bar);
      if (bb) bb.addEventListener('click', function () {
        if (fmt === 'gf') { ouvrirGF(); return; }
        if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      });
    }

    /* ────────── d'une œuvre à l'autre, au clavier ────────── */
    var prec = fic.getAttribute('data-prev');
    var suiv = fic.getAttribute('data-next');
    document.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (document.querySelector('dialog[open]')) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (t && t.closest && t.closest('[data-fic-track], .acc-slider__track')) return;
      if (e.key === 'ArrowLeft' && prec) window.location.href = prec;
      if (e.key === 'ArrowRight' && suiv) window.location.href = suiv;
    });
  }

  /* ────────── l'échelle (section suivante) ────────── */
  function echelle(root) {
    $$('[data-fis-scale]', root).forEach(function (box) {
      if (box.__fic) return;
      box.__fic = 1;
      var mur = $('[data-fis-wall]', box);
      var lib = $('[data-fis-scale-label]', box);
      var btns = $$('[data-fis-scale-btn]', box);
      function voir(f) {
        if (!mur) return;
        mur.setAttribute('data-echelle', f);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fis-scale-btn') === f ? 'true' : 'false'); });
        if (lib) lib.textContent = box.getAttribute('data-label-' + f) || '';
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { voir(b.getAttribute('data-fis-scale-btn')); }); });
      document.addEventListener('fic:format', function (e) { if (e.detail && box.getAttribute('data-label-' + e.detail.format)) voir(e.detail.format); });
    });
  }

  function tout(root) { demarrer(root || document); echelle(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tout(document); });
  else tout(document);
  document.addEventListener('shopify:section:load', function (e) { tout(e.target); });
})();
